(function(){
    VLW.controllers.Galerie = class extends VLW.controllers.base_mc {
        constructor(el, config) {
            super(el, config);
        }
        onRender(){
            super.onRender();
        }


        intro() {
            super.intro();
            setTimeout(this.isGALELOADED, 1);
        }

        outro() {
            super.outro();
            broadCaster.GALELOADED.remove(this.onGALELOADED);
        }
        isGALELOADED() {
            if (window.site.isLibraryGalerieLoaded === false) {
                broadCaster.GALELOADED.add(this.onGALELOADED);
                let a = document.createElement("script");
                let m = document.getElementsByTagName("script")[0];
                a.src = "/dist/js/galerie.js?"+CACHE_VERSION_SUFFIX;
                m.parentNode.insertBefore(a, m);
            } else {
                this.createGalerie();
            }
        }

        onGALELOADED() {
            this.createGalerie();
        }
        onGalleryBackToSite(){
            this.site.goBack();
        }
        createGalerie() {

            this.gallery = new $.Gallery({
                loaderurl				  : "/images/galerie/loader.gif",
                json                      : EXTRADATA["galleryData"],
                displayConfig             : {animType: VERSION_SMARTP ? "slideOut" : "cube"},
                el_Galerie_id             : "PageGalerie",
                el_TopBar_id              : "Galerie_TopBar",
                el_Mosaique_id            : "Galerie_Mosaique",
                el_Grille_id              : "Galerie_Grille",
                el_Display_id             : "Galerie_Display",
                el_ConfirmationDownload_id: "Galerie_ConfirmationDownload"
            });
            $(this.gallery).bind('categorieChange', $.proxy(this.onGalleryCatChange, this));
            $(this.gallery).bind('backToSite', $.proxy(this.onGalleryBackToSite, this));
            (site.currentPathname.split("/").length > 4) ? this.gallery.setCategorieFromUrl(site.currentPathname) : this.gallery.setFirstCategorie();
        }
    };
})();
